import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnPivotTable = _resolveComponent("KnPivotTable")

  return (_openBlock(), _createBlock(_component_KnPivotTable, {
    id: _ctx.id,
    columns: _ctx.filteredColumns,
    rows: _ctx.tempRows,
    propConfiguration: _ctx.propConfiguration,
    entity: _ctx.entity,
    pagination: _ctx.pagination,
    comboColumnOptions: _ctx.comboColumnOptions,
    numberOfRows: _ctx.registryDescriptor.paginationNumberOfItems,
    onRowChanged: _ctx.onRowChanged,
    onPageChanged: _ctx.onPageChange,
    onDropdownOpened: _ctx.addColumnOptions
  }, null, 8, ["id", "columns", "rows", "propConfiguration", "entity", "pagination", "comboColumnOptions", "numberOfRows", "onRowChanged", "onPageChanged", "onDropdownOpened"]))
}